// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** kf GET /kf/url */
export async function kfUrlUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.kfUrlUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultNpWwxKfSceneRelationResp>('/kf/url', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
